/**
 * CSRF token okuma + axios global yapılandırma yardımcıları.
 *
 * Profesyonel oturum yönetimi (Stage 3.X):
 * - Backend `pb_csrf` cookie'sini set eder (HttpOnly=False).
 * - Bu modül cookie'yi okur, axios'un her POST/PUT/PATCH/DELETE isteğine
 *   `X-CSRF-Token` header'ı olarak ekler.
 * - Cookie tabanlı auth için `withCredentials = true` zorunludur.
 */
import axios from "axios";

export const CSRF_COOKIE_NAME = "pb_csrf";
export const CSRF_HEADER_NAME = "X-CSRF-Token";

/** Belirtilen ada sahip cookie'yi okur (yoksa null). */
export function readCookie(name) {
  if (typeof document === "undefined") return null;
  const target = `${name}=`;
  const parts = (document.cookie || "").split(";");
  for (let i = 0; i < parts.length; i += 1) {
    const cookie = parts[i].trim();
    if (cookie.startsWith(target)) {
      return decodeURIComponent(cookie.substring(target.length));
    }
  }
  return null;
}

export function getCsrfToken() {
  return readCookie(CSRF_COOKIE_NAME);
}

const UNSAFE_METHODS = new Set(["post", "put", "patch", "delete"]);

let csrfInstalled = false;

/**
 * Tüm axios isteklerine CSRF + credentials davranışını ekler.
 * App.js'de bir kez çağrılır.
 */
export function installAxiosCsrfInterceptor() {
  if (csrfInstalled) return;
  csrfInstalled = true;

  axios.defaults.withCredentials = true;

  axios.interceptors.request.use((config) => {
    try {
      const method = (config.method || "get").toLowerCase();
      if (UNSAFE_METHODS.has(method)) {
        const token = getCsrfToken();
        if (token) {
          config.headers = config.headers || {};
          if (!config.headers[CSRF_HEADER_NAME] && !config.headers[CSRF_HEADER_NAME.toLowerCase()]) {
            config.headers[CSRF_HEADER_NAME] = token;
          }
        }
      }
      // withCredentials her istek için açık olsun (axios.create ile yapılan instance'lar dahil)
      if (config.withCredentials !== false) {
        config.withCredentials = true;
      }
    } catch (_) {
      /* ignore */
    }
    return config;
  });
}

export default { installAxiosCsrfInterceptor, getCsrfToken, readCookie };
